import { getChangePictureHistory } from "@/api/picture";
export default {
    state: {

        history: [],
    },

    mutations: {

        SET_PICTURE_HISTORY: (state, data) => {
            state.history = data;
        },
    },

    actions: {

        getChangePictureHistory({ commit }) {
            commit("SET_TABLE_TEXT", true);
            return new Promise((resolve, reject) => {
                getChangePictureHistory()
                    .then((response) => {
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        commit("SET_PICTURE_HISTORY", data);
                        commit("SET_TABLE_TEXT", false);

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};